<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer004" role="doc-foreword">
<p class="fl-fl-roman"><b>Terri Reed</b>’s romance and romantic suspense novels have appeared on the <i>Publishers Weekly</i> top twenty-five and Nielsen BookScan top one hundred lists, and have been featured in <i>USA TODAY</i>, <i>Christian Fiction</i> magazine and <i>RT Book Reviews</i>. Her books have been finalists for the Romance Writers of America RITA® Award and the National Readers’ Choice Award, and finalists three times for the American Christian Fiction Writers Carol Award. Contact Terri at <a href="http://www.terrireed.com" target="_blank">terrireed.com</a> or PO Box 19555, Portland, OR 97224.</p>
<p class="pl-center"><b>Books by Terri Reed</b></p>
<p class="pl-booklist-series"><b>Love Inspired Suspense</b></p>
<p class="pl-booklist-titles">Buried Mountain Secrets</p>
<p class="pl-booklist-titles">Secret Mountain Hideout</p>
<p class="pl-booklist-miniseries"><span class="bold-italic">True Blue K-9 Unit: Brooklyn</span></p>
<p class="pl-booklist-titles">Explosive Situation</p>
<p class="pl-booklist-miniseries"><span class="bold-italic">True Blue K-9 Unit</span></p>
<p class="pl-booklist-titles">Seeking the Truth</p>
<p class="pl-booklist-miniseries"><span class="bold-italic">Military K-9 Unit</span></p>
<p class="pl-booklist-titles">Tracking Danger </p>
<p class="pl-booklist-titles">Mission to Protect</p>
<p class="pl-booklist-miniseries"><span class="bold-italic">Classified K-9 Unit</span></p>
<p class="pl-booklist-titles">Guardian</p>
<p class="pl-booklist-titles">Classified K-9 Unit Christmas</p>
<p class="pl-booklist-titles"><span class="roman">“Yuletide Stalking”</span></p>
<p class="pl-center">Visit the Author Profile page at <a href="http://Harlequin.com" target="_blank">Harlequin.com</a> for more titles.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_the_Author.vue?0404524b